import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star-full",
  "use": "star-full-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"star-full\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.688 21.997a.786.786 0 01-.767-.96l1.58-7.145-5.266-5.2a.789.789 0 01.524-1.347l6.834-.232L10.272.447c.239-.597 1.218-.595 1.458 0l2.678 6.657 6.835.243c.313.01.59.207.704.5a.795.795 0 01-.18.847l-5.258 5.2 1.57 7.148a.789.789 0 01-1.189.836L11 18.126l-5.891 3.749a.798.798 0 01-.421.122z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol